<template>
	<div>
		<div class="tw-text-3xl tw-font-bold" v-if="!isDone">
			{{ $t('integrations.sync-categories-title', { marketplace }) }}
		</div>
		<div class="tw-flex tw-items-center tw-gap-2" v-else>
			<div class="tw-text-3xl tw-font-bold">{{ $t('integrations.categories-synced') }}</div>
			<div
				class="'tw-border-secondary-500 tw-z-10 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-bg-secondary-500 tw-text-white"
				style="width: 32px; height: 32px"
			>
				<AppIcon name="check" />
			</div>
		</div>
		<div class="tw-font-medium tw-text-gray-500">
			{{ $t('integrations.sync-categories-description', { marketplace }) }}
		</div>
		<div class="tw-mt-5" v-if="!isDone">
			<AppButton
				:label="loading ? $t('integrations.syncing') : $t('integrations.sync-categories')"
				size="xl"
				endIcon="assets/v2/image/icons/refresh.svg"
				class="tw-rounded-full"
				:disabled="loading"
			/>
		</div>
		<div class="tw-mt-5 tw-flex tw-items-center tw-gap-3" v-else>
			<AppButton
				:label="$t('integrations.resync-categories')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				secondary
				variant="gray"
				endIcon="assets/v2/image/icons/refresh.svg"
				@click="resync"
			/>
			<AppButton
				:label="$t('integrations.next-step')"
				size="xl"
				class="tw-rounded-full"
				type="button"
				endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
				@click="nextStep"
			/>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';

const loading = ref(false);
const isDone = ref(false);

// TODO: dynamic
const marketplace = 'Shopify';

const resync = () => {};
const nextStep = () => {};
</script>

<style lang="scss" scoped></style>
